import React, { memo, useContext, useEffect, useState } from 'react';
import { getEntityInstance } from 'src/store/actions/entityInfoActions';
import { useDispatch } from 'react-redux';
// eslint-disable-next-line import/no-cycle
import EntityCard from 'src/components/EntityInspector/EntityInspectorDialog/EntityCard/EntityCard';
import EntityContext from 'src/components/EntityInspector/context';
function EntityInstance({ entity }) {
    const dispatch = useDispatch();
    const { endpoint } = useContext(EntityContext);
    const [loading, setLoading] = useState(false);
    const [entityInstanceData, setEntityInstanceData] = useState();
    const loadInstance = async (ent) => {
        const { id, name } = ent;
        const data = await dispatch(getEntityInstance({ Entity: name, Id: id }, endpoint));
        setEntityInstanceData(data);
    };
    useEffect(() => {
        setLoading(true);
        loadInstance(entity)
            .catch((e) => console.error(e))
            .finally(() => setLoading(false));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [entity]);
    if (loading)
        return React.createElement("div", null,
            React.createElement("i", null, "Loading..."));
    if (!entityInstanceData)
        return React.createElement("div", null,
            React.createElement("i", null, "No data"));
    return (React.createElement(EntityCard, { primaryKeyValue: entity.id, attributes: entityInstanceData }));
}
export default memo(EntityInstance);
